type HydraCollection = {
    'hydra:member': Array<unknown>;
    'hydra:totalItems'?: number;
};

/**
 * Exclut les items « soft-deleted » (`deleted === true`) d'une réponse de
 * collection Hydra.
 *
 * La plupart des endpoints de l'API Offre n'exposent pas de filtre serveur
 * `deleted` (seul `apiArticlesGetCollection` en possède un) : le filtrage est
 * donc réalisé côté client sur `hydra:member`. `hydra:totalItems` est ajusté du
 * nombre d'items retirés sur la page courante.
 *
 * @param response - Réponse de collection renvoyée par l'API.
 * @returns La même réponse, privée de ses items supprimés.
 */
export const filterDeletedCollection = <R extends HydraCollection>(response: R): R => {
    const members = response['hydra:member'] ?? [];
    const filtered = members.filter(
        (member) => (member as { deleted?: unknown } | null)?.deleted !== true,
    );

    if (filtered.length === members.length) {
        return response;
    }

    const total = response['hydra:totalItems'];
    const removed = members.length - filtered.length;

    return {
        ...response,
        'hydra:member': filtered,
        ...(typeof total === 'number' ? { 'hydra:totalItems': Math.max(total - removed, 0) } : {}),
    } as R;
};

export default filterDeletedCollection;
